export default () => ({
  root: { backgroundColor: '#fff', width: 'calc(100% - 1px)' },
});
